import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import moment from "moment";

import {
    fetchAllBookings,
    servicemenUpdateBooking,
    updateBookingStatus,
} from "../redux/slices/bookingSlice";

const TABS = [
    { label: "All", value: "" },
    { label: "Pending", value: "pending" },
    { label: "Accepted", value: "accepted" },
    { label: "Completed", value: "completed" },
    { label: "Cancelled", value: "cancelled" },
];

export default function AllBookings() {
    const dispatch = useDispatch();
    const { bookings, meta, loading } = useSelector((state) => state.booking);

    const [activeTab, setActiveTab] = useState("");
    const [bookingId, setBookingId] = useState("");
    const [page, setPage] = useState(1);

    /* ================= FETCH BOOKINGS ================= */
    useEffect(() => {
        dispatch(
            fetchAllBookings({
                status: activeTab || undefined,
                bookingId: bookingId || undefined,
                page,
                limit: 50,
            })
        );
    }, [dispatch, activeTab, bookingId, page]);

    /* ================= ACTION CONFIRM ================= */
    const confirmAction = async (title, text, callback) => {
        const result = await Swal.fire({
            title,
            text,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#198754",
            cancelButtonColor: "#dc3545",
            confirmButtonText: "Yes",
        });

        if (result.isConfirmed) {
            callback();
        }
    };

    return (
        <div className="container-fluid mt-3">
            <div className="card shadow-sm">
                {/* ================= HEADER ================= */}
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">All Bookings</h5>

                    <input
                        type="text"
                        className="form-control w-25"
                        placeholder="Search Booking ID"
                        value={bookingId}
                        onChange={(e) => {
                            setPage(1);
                            setBookingId(e.target.value);
                        }}
                    />
                </div>

                {/* ================= BODY ================= */}
                <div className="card-body">
                    {/* -------- TABS -------- */}
                    <ul className="nav nav-tabs mb-3">
                        {TABS.map((tab) => (
                            <li className="nav-item" key={tab.label}>
                                <button
                                    className={`nav-link ${activeTab === tab.value ? "active" : ""
                                        }`}
                                    onClick={() => {
                                        setPage(1);
                                        setActiveTab(tab.value);
                                    }}
                                >
                                    {tab.label}
                                </button>
                            </li>
                        ))}
                    </ul>

                    {/* -------- TABLE -------- */}
                    <div className="table-responsive">
                        <table className="table table-bordered table-hover align-middle">
                            <thead className="table-light">
                                <tr>
                                    <th>#</th>
                                    <th>Booking ID</th>
                                    <th>Customer</th>
                                    <th>Servicemen</th>
                                    <th>Date</th>
                                    <th>Status</th>
                                </tr>
                            </thead>

                            <tbody>
                                {loading && (
                                    <tr>
                                        <td colSpan="6" className="text-center">
                                            Loading...
                                        </td>
                                    </tr>
                                )}

                                {!loading && bookings.length === 0 && (
                                    <tr>
                                        <td colSpan="6" className="text-center text-muted">
                                            No bookings found
                                        </td>
                                    </tr>
                                )}

                                {bookings.map((b, i) => (
                                    <tr key={b._id}>
                                        <td>{(page - 1) * 50 + i + 1}</td>
                                        <td>{b.bookingId}</td>
                                        <td>
                                            {b.customer?.name}
                                            <br />
                                            <small>{b.customer?.phone}</small>
                                        </td>
                                        <td>{b.servicemen?.displayName || "Useraname N/A"}, {b.servicemen?.user?.name}</td>
                                        <td>
                                            {moment(b.date).format("DD MMM YYYY")}
                                            <br />
                                            <small>{b.time}</small>
                                        </td>
                                        <td>
                                            <span
                                                className={`badge ${b.status === "completed"
                                                        ? "bg-success"
                                                        : b.status === "confirmed"
                                                            ? "bg-primary"
                                                            : b.status === "cancelled"
                                                                ? "bg-danger"
                                                                : "bg-warning text-dark"
                                                    }`}
                                            >
                                                {b.status}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* -------- PAGINATION -------- */}
                    {meta && meta.totalPages > 1 && (
                        <div className="d-flex justify-content-end gap-2">
                            <button
                                className="btn btn-outline-secondary btn-sm"
                                disabled={page === 1}
                                onClick={() => setPage(page - 1)}
                            >
                                Prev
                            </button>

                            <span className="align-self-center">
                                Page {meta.page} of {meta.totalPages}
                            </span>

                            <button
                                className="btn btn-outline-secondary btn-sm"
                                disabled={page === meta.totalPages}
                                onClick={() => setPage(page + 1)}
                            >
                                Next
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
